<template>
  <fullscreen-modal :visible.sync="visible" :title="'查看试压报单'" :close-on-click-modal="false" @close="handleClose">
    <div class="view-declaration-modal">
      <el-form :model="info" ref="infoForm" label-width="140px" class="declaration-form">
        <!-- 商户信息 -->
        <el-card shadow="hover" class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-shop"></i>
            <span>商户信息</span>
          </div>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="报单商家名称:">
                <span class="value">{{ info.shopName || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报单商家电话:">
                <span class="value">{{ info.shopMobile || '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="报单商家地址:">
                <span class="value">{{ info.shopAddress || '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <!-- 联系人与业主 -->
        <el-card shadow="hover" class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-user"></i>
            <span>联系人与业主</span>
          </div>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="联系人姓名:">
                <span class="value">{{ info.contactName || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人电话:">
                <span class="value">{{ info.contactMobile || '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="联系人类型:">
                <span class="value">{{ customerTypeLabel }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="业主姓名:">
                <span class="value">{{ info.customName || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="业主手机:">
                <span class="value">{{ info.customMobile || '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="黑名单校验手机号:">
                <span class="value">{{ info.appointmentPhone || '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <!-- 装修与水工 -->
        <el-card shadow="hover" class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-office-building"></i>
            <span>装修与水工</span>
          </div>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="装修公司:">
                <span class="value">{{ info.otherRequirements || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="装修公司电话:">
                <span class="value">{{ info.otherProducts || '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="水工姓名:">
                <span class="value">{{ info.introducer || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="水工电话:">
                <span class="value">{{ info.reference || '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="项目经理名称:">
                <span class="value">{{ info.lineLength || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="入场时间:">
                <span class="value">{{ entranceTimeText }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <!-- 施工地址 -->
        <el-card shadow="hover" class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-location-outline"></i>
            <span>施工地址</span>
          </div>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="施工地址:">
                <span class="value">{{ info.customAddress || '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <!-- 备注与配置 -->
        <el-card shadow="hover" class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-document"></i>
            <span>备注与配置</span>
          </div>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="备注:">
                <span class="value value-multiline">{{ info.remarks || '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="面积配置:">
                <el-table
                  v-if="info.areaConfig && info.areaConfig.length"
                  :data="info.areaConfig"
                  border
                  stripe
                  size="small"
                  class="area-table"
                >
                  <el-table-column prop="name" label="名称" min-width="120" />
                  <el-table-column prop="area" label="面积(㎡)" min-width="100" />
                  <el-table-column prop="productName" label="商品名称" min-width="160" />
                </el-table>
                <span v-else class="value value-empty">暂无面积配置</span>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-card>

        <div class="btn-group">
          <el-button type="danger" size="small" @click="handleClose" icon="el-icon-circle-close-outline">关闭</el-button>
        </div>
      </el-form>
    </div>
  </fullscreen-modal>
</template>

<script>
import { getMerchantOrder, getAreaConfigById } from "@/api/work/pipeline/merchants";
import FullscreenModal from "@/views/work/pipeline/merchants/components/fullscreen-modal.vue";

export default {
  name: "ViewPipelineTestingDeclarationModal",
  components: {
    FullscreenModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      info: {
        shopName: "",
        shopMobile: "",
        shopAddress: "",
        contactName: "",
        contactMobile: "",
        appointmentType: "",
        customName: "",
        customMobile: "",
        customAddress: "",
        appointmentPhone: "",
        otherRequirements: "",
        otherProducts: "",
        introducer: "",
        reference: "",
        lineLength: "",
        entranceTime: "",
        remarks: "",
        areaConfig: [],
      },
    };
  },
  computed: {
    customerTypeLabel() {
      const map = {
        1: "业主",
        2: "水工",
        3: "工长",
        4: "经销商",
        5: "项目经理",
        6: "装饰公司",
      };
      return map[this.info.appointmentType] || "-";
    },
    entranceTimeText() {
      const t = this.info.entranceTime;
      if (!t) return "-";
      const d = new Date(Number(t) || t);
      if (isNaN(d.getTime())) return "-";
      return d.toLocaleDateString();
    },
  },
  watch: {
    visible(val) {
      if (val && this.id) {
        this.loadData();
      }
    },
  },
  methods: {
    loadData() {
      this.resetData();
      this.getMerchantOrderData();
    },
    resetData() {
      this.info = {
        shopName: "",
        shopMobile: "",
        shopAddress: "",
        contactName: "",
        contactMobile: "",
        appointmentType: "",
        customName: "",
        customMobile: "",
        customAddress: "",
        appointmentPhone: "",
        otherRequirements: "",
        otherProducts: "",
        introducer: "",
        reference: "",
        lineLength: "",
        entranceTime: "",
        remarks: "",
        areaConfig: [],
      };
    },
    getMerchantOrderData() {
      getMerchantOrder(this.id).then((res) => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.info = {
            ...this.info,
            ...data,
          };
          this.getAreaConfig();
        }
      });
    },
    getAreaConfig() {
      getAreaConfigById(this.id).then((res) => {
        if (res.code == "200") {
          const areaData = JSON.parse(res.data);
          this.info.areaConfig = areaData || [];
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.view-declaration-modal {
  min-height: 100%;
  padding: 4px;
}

.declaration-form {
  ::v-deep .el-form-item {
    margin-bottom: 18px;
  }
  ::v-deep .el-form-item__label {
    color: #909399;
    font-size: 13px;
  }
}

.card {
  margin-bottom: 20px;
  border-radius: 6px;
}

.card-header {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #303133;
  font-size: 15px;
  i {
    margin-right: 8px;
    color: #409eff;
    font-size: 16px;
  }
}

.value {
  color: #303133;
  font-size: 14px;
  word-break: break-all;
}

.value-multiline {
  white-space: pre-wrap;
}

.value-empty {
  color: #c0c4cc;
  font-size: 14px;
}

.area-table {
  margin-top: 4px;
  width: 100%;
}

.btn-group {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  gap: 10px;
}
</style>
